import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

export default function ProtectedRoute({ children }) {
  const { auth } = useContext(AuthContext);

  if (!auth.token) {
    // Nu e logat → redirecționează la login
    return <Navigate to="/login" replace />;
  }

  // Dacă e logat, afișează copilul (pagina protejată)
  return children;
}
